import React from 'react';
import classnames from 'classnames';
import { type DateRangePickerProps as BaseDateRangePickerProps, DateRangePicker as DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { Colors } from '@/styles/colors';
import styles from './Picker.module.scss';

export interface DateRangePickerProps extends BaseDateRangePickerProps {
  className?: string;
  onClose?: () => void;
}
export const DateRangePicker: React.FC<DateRangePickerProps> = ({ className, ranges, ...rest }) => (
  <DateRange
    ranges={ranges}
    rangeColors={Array(ranges?.length || 1).fill(Colors.Sienna)}
    className={classnames(styles.root, { hasStaticRanges: !!rest.staticRanges?.length }, className)}
    {...rest}
  />
);
